import {call, put, takeLatest} from "redux-saga/effects";
import {
    doneLogin,
    doneRegister,
    doneResetPassword,
    doneResetPasswordConfirm,
    doneUpdatePassword,
    errorLogin,
    errorRegister,
    errorResetPassword,
    errorResetPasswordConfirm,
    errorUpdatePassword
} from "../actions/user";
import Api from "../services/api";
import LocalStorage from "../../util/localStorage";
import {getCurrentTimeSeconds} from "../../util/util";
import {checkUserHelper} from "../services/api-util";

export function* loginCall(action) {
    const result = yield call(Api.login, action.data.username, action.data.password, action.data.captcha_token);

    if (result && result.status === 0) {
        const infoResult = yield call(Api.userInfo, result.data);

        if (infoResult && infoResult.status === 0) {
            let user = Object.assign(result.data, infoResult.data);
            user.obtain_time = getCurrentTimeSeconds();

            let lookupsResult = yield call(Api.getLookups, user);

            LocalStorage.set('user', user);
            LocalStorage.set('lookup', lookupsResult.data);

            yield put(doneLogin(user));

        } else {
            yield put(errorLogin(infoResult.data));
        }
    } else {
        yield put(errorLogin(result.data));
    }
}

export function* watchLoginCall() {
    yield takeLatest('LOGIN', loginCall);
}

export function* resetPasswordCall(action) {
    const result = yield call(Api.resetPassword, action.data.username);

    if (result && result.status === 0) {
        yield put(doneResetPassword(result.data));
    } else {
        yield put(errorResetPassword(result.data));
    }
}

export function* watchResetPasswordCall() {
    yield takeLatest('RESET_PASSWORD', resetPasswordCall);
}

export function* resetPasswordConfirmCall(action) {
    const result = yield call(Api.resetPasswordConfirm, action.data.username, action.data.token, action.data.password);

    if (result && result.status === 0) {
        yield put(doneResetPasswordConfirm(result.data));
    } else {
        yield put(errorResetPasswordConfirm(result.data));
    }
}

export function* watchResetPasswordConfirmCall() {
    yield takeLatest('RESET_PASSWORD_CONFIRM', resetPasswordConfirmCall);
}

export function* registerCall(action) {
    let result;

    if (!!action.data.params.registerCompany) {
        result = yield call(Api.registerCompany, action.data.params);
    } else {
        result = yield call(Api.register, action.data.params);
    }

    if (result && result.status === 0) {
        if (action.data.Resume) {

        }
        if (action.data.Photo) {

        }
        yield put(doneRegister(result.data));
    } else {
        yield put(errorRegister(result));
    }
}

export function* watchRegisterCall() {
    yield takeLatest('REGISTER', registerCall);
}

export function* updatePasswordCall(action) {
    const user = yield* checkUserHelper(action.data.user);

    const result = yield call(Api.updatePassword, user, action.data.params);

    if (result && result.status === 0) {
        yield put(doneUpdatePassword(result.data));
    } else {
        yield put(errorUpdatePassword(result.data));
    }
}

export function* watchUpdatePasswordCall() {
    yield takeLatest('UPDATE_PASSWORD', updatePasswordCall);
}